// @flow

export const AlertServiceLengthPeriodTypeEnum = {
  DAY: "D",
  WEEK: "W",
  MONTH: "M",
};

export const AlertServiceLengthMoreOrLessThanEnum: { [string]: string } = {
  LESS_THAN: "LESS_THAN",
  MORE_THAN: "MORE_THAN",
};
